export const backEndStacks = [
    'PHP',
    'Nodejs',
    'Python',
    'Go',
    'Flask',
    'Django',
    'Laravel',
    'Java',
    'C#',
    'C++',
    '.NET',
    'Ruby',
    'Scala',
    'Perl',
    'Symfony',
    'Spring',
    'JSF',
    'Others',
];

export const stacks = [
    'Frontend',
    'Backend',
    'Full Stack',
    'Mobile',
    'Machine Learning',
    'Product Manager',
    'UI/UX Designer',
    'Blockchain',
    'Data Science',
    'Pen Testing',
    'DevOps',
    'Others',
];

export const frontEndStacks = [
    'HTML, CSS, JavaScript',
    'Vue',
    'React',
    'Angular',
    'jQuery',
    'Svelte',
    'Gatsby',
    'Next',
    'Nuxt',
    'Gridsome',
    'Others',
];

export const uiTools = [
    'Sketch',
    'Wireframe.cc',
    'Adobe XD',
    'Figma',
    'InVision Studio',
    'Axure',
    'Craft',
    'Proto.io',
    'Marvel',
    'Framer X',
    'Webflow',
    'Origami Studio',
    'FlowMapp',
    'Balsamiq',
    'VisualSitemaps',
    'Treejack',
    'Optimal Workshop',
];

export const pmTools = [
    'Jira',
    'Trello',
    'Gitlab',
    'Microsoft Project',
    'Miro',
    'ClickUp',
    'Airtable',
    'MindView',
    'Microsoft Excel',
    'Github',
];

export const levels = [
    {
        id: 1,
        level: 'Junior',
        work_rate: '$5 - $15',
    },
    {
        id: 2,
        level: 'Intermediate',
        work_rate: '$10 - $30',
    },
    {
        id: 3,
        level: 'Senior',
        work_rate: '$15 - $60',
    },
];

export const categories = ['Algorithms', 'Peer Programming'];

// export const tags = [
//   'Database programming',
//   'DevOps',
//   'Coding',
//   'Frontend programming',
//   'Backend programming',
//   'HTML/CSS/JavaScript programming',
// ];

export const jobTypes = [
    //   {
    //     id: 1,
    //     type: 'Freelance',
    //   },
    {
        id: 2,
        type: 'Full-time',
    },

    {
        id: 3,
        type: 'Contract',
    },

    //   {
    //     id: 0,
    //     type: 'Crowdsource Project',
    //   },
];

export const honors = [
    {
        honor: "Associate's degree",
    },
    {
        honor: 'Associate of Arts - AA',
        title: 'AA',
    },
    {
        honor: 'Associate of Arts and Sciences',
        title: 'AAS',
    },
    {
        honor: 'Associate of Science',
        title: 'AS',
    },
    {
        honor: 'Bachelor of Applied Science',
        title: 'BASc',
    },
    {
        honor: 'Bachelor of Architecture',
        title: 'BArch',
    },
    {
        honor: 'Bachelor of Arts',
        title: 'BA',
    },
    {
        honor: 'Bachelor of Business Administration',
        title: 'BBA',
    },
    {
        honor: 'Bachelor of Fine Arts',
        title: 'BFA',
    },
    {
        honor: 'Master of Architecture',
        title: 'MArch',
    },
    {
        honor: 'Master of Arts',
        title: 'MA',
    },
    {
        honor: 'Master of Business Administration',
        title: 'MBA',
    },
    {
        honor: 'Master of Computer Applications - MCA',
        title: '',
    },
    {
        honor: '',
        title: '',
    },
    {
        honor: '',
        title: '',
    },
];

const mobileStacks = ['Flutter', 'Ionic', 'React Native', 'C#'];

export const otherStacks = {
    mobile: [...mobileStacks, 'Java', 'Kotlin', 'Swift', 'Objective-C'],
    'machine-learning': ['Python', 'R & Julie'],
    blockchain: ['Truffle', 'Genache', 'LLL', 'Serpent', 'Zeplin', 'DApp', 'Solidity'],
    'data-science': ['Python', 'R & Julie', 'SQL'],
    'pen-testing': ['Wire shark', 'N-map', 'MetaSploid/Armitage', 'Python'],
    devops: ['Azure', 'GCP', 'AWS', 'Docker', 'Kubernetes', 'Jenkins', 'TravisCI', 'CI/CD'],
};

export const allStacks = [
    ...backEndStacks,
    ...frontEndStacks,
    ...uiTools,
    ...pmTools,
    ...otherStacks.mobile,
    ...otherStacks['machine-learning'],
    ...otherStacks.blockchain,
    ...otherStacks['data-science'],
    ...otherStacks['pen-testing'],
    ...otherStacks.devops,
];
